//node modules
import { useState } from "react";

//styles
import logo from "../../assets/images/logo.png";
import UnileverIcon from "../../assets/images/logo.png";

const Navbar = (props) => {
  const [menu] = useState({
    tr: [
      {
        text: "DIGI-CALL NEDİR?",
        link: "digicall-nedir",
      },
      {
        text: "UNILEVER DİJİTAL EKİP",
        link: "unilever-dijital-ekip",
      },
      {
        text: "KİMLER BAŞVURABİLİR?",
        link: "kimler-basvurabilir",
      },
      {
        text: "SÜREÇ",
        link: "surec",
      },
      {
        text: "PROGRAM",
        link: "program",
      },
      {
        text: "S.S.S",
        link: "sss",
      },
    ],
    eng: [
      {
        text: "WHAT IS DIGI-CALL?",
        link: "what-is-digicall",
      },
      {
        text: "UNILEVER DIGITAL TEAM",
        link: "unilever-digital-team",
      },
      {
        text: "WHO CAN APPLY?",
        link: "who-can-apply",
      },
      {
        text: "PROCESS",
        link: "process",
      },
      {
        text: "PROGRAM",
        link: "program",
      },
      {
        text: "F.A.Q",
        link: "faq",
      },
    ],
  });

  const [toggle, setToggle] = useState(false);

  const OpenMenu = () => {
    setToggle(true);
    document.body.style.overflow = "hidden";
  };
  const CloseMenu = () => {
    setToggle(false);
    document.body.style.overflowY = "auto";
  };

  return (
    <section className="w-full flex justify-center items-center bg-[#00D7C4] fixed z-10 shadow-lg">
      <div className="w-4/5 max-w-screen-xl py-3 flex flex-row justify-between items-center">
        <img
          className="cursor-pointer"
          onClick={() => {
            window.scrollTo(0, 0);
          }}
          width="63px"
          src={logo}
          alt="unilever logo"
        />
        <ul className="hidden lg:flex flex-row text-white lg:text-xs xl:text-base font-medium space-x-3 xl:space-x-6">
          {props.currentLang === "eng"
            ? menu.eng.map((item, index) => {
                return (
                  <li
                    key={index}
                    className="hover:text-[#1F36C7] transition-all duration-200"
                  >
                    <a href={"/#" + item.link}>{item.text}</a>
                  </li>
                );
              })
            : menu.tr.map((item, index) => {
                return (
                  <li
                    key={index}
                    className="hover:text-[#1F36C7] transition-all duration-200"
                  >
                    <a href={"/#" + item.link}>{item.text}</a>
                  </li>
                );
              })}
        </ul>
        <div className="hidden space-x-5 lg:flex flex-row">
          <a
            className="block lg:text-base xl:text-xl font-bold text-white rounded-[5px] bg-[#1F36C7] px-4 py-1 hover:text-[#00D7C4] transition-all duration-200"
            href={props.currentLang === "eng" ? "/#register" : "/#basvur"}
          >
            {props.currentLang === "eng" ? "APPLY NOW" : "HEMEN BAŞVUR"}
          </a>
          <button
            onClick={() => {
              props.currentLang === "tr"
                ? props.setCurrentLang("eng")
                : props.setCurrentLang("tr");
            }}
            className="text-sm xl:text-base whitespace-nowrap text-white uppercase font-medium select-none"
          >
            <span
              className={
                props.currentLang === "tr"
                  ? "text-[#1F36C7] text-lg transition-all duration-300"
                  : ""
              }
            >
              TR
            </span>
            /
            <span
              className={
                props.currentLang === "eng"
                  ? "text-[#1F36C7] text-lg transition-all duration-300"
                  : ""
              }
            >
              ENG
            </span>
          </button>
        </div>
        <div
          onClick={OpenMenu}
          className="lg:hidden flex flex-col space-y-2 p-2 border border-[#1F36C7] rounded-md"
        >
          <div className="w-[22px] h-[2px] bg-[#1F36C7] rounded-xl"></div>
          <div className="w-[22px] h-[2px] bg-[#1F36C7] rounded-xl"></div>
          <div className="w-[22px] h-[2px] bg-[#1F36C7] rounded-xl"></div>
        </div>
      </div>
      <div
        className={
          toggle
            ? "block w-4/5 h-screen1 fixed bg-[#00D7C4] top-0 bottom-0 right-0 z-30 overflow-y-auto select-none transition-all duration-200 shadow-xl"
            : "block w-4/5 h-screen1 fixed bg-[#00D7C4] top-0 bottom-0 e-right-4_5 z-30  overflow-y-auto select-none transition-all duration-200 shadow-xl"
        }
      >
        <div className="relative w-100 h-100 py-16">
          <div
            onClick={CloseMenu}
            className=" p-4 bg-transparent absolute top-8 right-9 flex justify-center items-center rounded-md transition-all duration-200"
          >
            <div className="w-8 h-1 bg-[#1F36C7] rounded-sm rotate-45 absolute"></div>
            <div className="w-8 h-1 bg-[#1F36C7] rounded-sm -rotate-45 absolute"></div>
          </div>
          <ul className="flex flex-col space-y-5 divide-y pl-5">
            {props.currentLang === "eng"
              ? menu.eng.map((item, index) => {
                  return (
                    <li onClick={CloseMenu} key={index} className="mx-2 pt-5">
                      <a
                        className="block w-100 h-100 text-white text-xl font-bold uppercase focus-text-yellow-custom bg-transparent hover:text-[#1F36C7] transition-all duration-200"
                        href={"/#" + item.link}
                      >
                        {item.text}
                      </a>
                    </li>
                  );
                })
              : menu.tr.map((item, index) => {
                  return (
                    <li onClick={CloseMenu} key={index} className="mx-2 pt-5">
                      <a
                        className="block w-100 h-100 text-white text-xl font-bold uppercase focus-text-yellow-custom bg-transparent hover:text-[#1F36C7] transition-all duration-200"
                        href={"/#" + item.link}
                      >
                        {item.text}
                      </a>
                    </li>
                  );
                })}
          </ul>
          <div className="w-full flex flex-col items-center mt-6 space-y-3">
            <a
              onClick={CloseMenu}
              className="p-3 block text-white bg-[#1F36C7] hhover text-xl font-bold uppercase rounded-md"
              href={props.currentLang === "eng" ? "/#register" : "/#basvur"}
            >
              {props.currentLang === "eng" ? "APPLY NOW" : "HEMEN BAŞVUR"}
            </a>
            <button
              onClick={() => {
                props.currentLang === "tr"
                  ? props.setCurrentLang("eng")
                  : props.setCurrentLang("tr");
              }}
              className="text-sm xl:text-base whitespace-nowrap text-white uppercase font-medium select-none"
            >
              <span
                className={
                  props.currentLang === "tr"
                    ? "text-[#1F36C7] text-lg transition-all duration-300"
                    : ""
                }
              >
                TR
              </span>
              /
              <span
                className={
                  props.currentLang === "eng"
                    ? "text-[#1F36C7] text-lg transition-all duration-300"
                    : ""
                }
              >
                ENG
              </span>
            </button>
          </div>
          <div className="absolute w-full flex justify-center">
            <img
              className="w-12 my-10"
              src={UnileverIcon}
              alt="unilever icon"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Navbar;
